import React, { useEffect, Suspense, lazy } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { ResetCSS } from '@pancakeswap-libs/uikit'
import BigNumber from 'bignumber.js'
import { useFetchPublicData } from 'state/hooks'
import CookieConsent, { Cookies } from "react-cookie-consent";
import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import PageLoader from './components/PageLoader'

// Route-based code splitting
// Only pool is included in the main bundle because of it's the most visited page'
const Home = lazy(() => import('./views/Home'))
const Farms = lazy(() => import('./views/Farms'))
// const Lottery = lazy(() => import('./views/Lottery'))
// const Pools = lazy(() => import('./views/Pools'))
// const Ifos = lazy(() => import('./views/Ifos'))
const NotFound = lazy(() => import('./views/NotFound'))
const ComingSoon = lazy(() => import('./views/ComingSoon'))
// const Nft = lazy(() => import('./views/Nft'))

// This config is required for number formating
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})



const App: React.FC = () => {
  const { account, connect } = useWallet()
  useEffect(() => {
    if (!account && window.localStorage.getItem('accountStatus')) {
      connect('injected')
    }
  }, [account, connect])

  useFetchPublicData()

  return (
    <Router>
      <ResetCSS />
      <GlobalStyle />
      <CookieConsent
          location = "bottom"
          buttonText="Accept"
          enableDeclineButton
          declineButtonText = "Decline"
          declineButtonStyle = {{
            padding: "10px 20px",
            fontSize: "16px",
            boxShadow: "inset 0 -1px 0 0 rgba(14,14,44,.4)",
            height: "40px",
            backgroundColor: "#e69f35",
            color: "#fff",
            borderRadius: "5px",
            textTransform: "uppercase",
            lineHeight: "24px"
          }}
          style={{ right: "10px !important" }}
          cookieName="pankukucookieStore"
          onDecline={() => {
            console.log("Sdf")
          }}
          buttonStyle={{
            padding: "10px 20px",
            fontSize: "16px",
            boxShadow: "inset 0 -1px 0 0 rgba(14,14,44,.4)",
            height: "40px",
            backgroundColor: "#e69f35",
            color: "#fff",
            borderRadius: "5px",
            textTransform: "uppercase",
            lineHeight: "24px"
          }}
        >
        <h3>This website uses cookies.</h3>
          <span style={{ fontSize: "15px" }}>We use cookies to analyze website traffic and optimize your website experience. By accepting our use of cookies, your data will be aggregated with all other user data. </span>
        </CookieConsent>

      <Menu>
        <Suspense fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/farms">
              <Farms />
            </Route>
            <Route path="/pools">
              <Farms tokenMode/>
            </Route>
            <Route path="/comingsoon">
             <ComingSoon />
            </Route>
            {/* <Route path="/lottery"> */}
            {/*  <Lottery /> */}
            {/* </Route> */}
            {/* <Route path="/ifo"> */}
            {/*  <Ifos /> */}
            {/* </Route> */}
            {/* <Route path="/nft"> */}
            {/*  <Nft /> */}
            {/* </Route> */}
            {/* Redirect */}
            {/* <Route path="/staking"> */}
            {/*  <Redirect to="/pools" /> */}
            {/* </Route> */}
            {/* <Route path="/syrup"> */}
            {/*  <Redirect to="/pools" /> */}
            {/* </Route> */}
            {/* 404 */}
            <Route component={NotFound} />

          </Switch>
        </Suspense>
      </Menu>
    </Router>
  )
}

export default React.memo(App)
